import { Component,OnInit,HostListener,Inject,ViewChild} from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import * as LZString from 'lz-string';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {

  constructor(public _ss:StoreService,public router:Router,public _fb:FormBuilder) { }

  public form:FormGroup

  public Customer

  public Loading = false

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  ngOnInit(): void {
    
    if(this._ss.CustomerChoose === null){
      this.Back()
    }else{
      this.Customer =  this._ss.CustomerChoose 

      window.scrollTo(0, 0);

      this.form = this._fb.group({
        CustName:["",Validators.required],
        CustNum:["",Validators.required],
        CustServer:["",Validators.required],
        CustImageDomain:["",Validators.required],
        CustSeeImages:["",Validators.required],
        CustSeeImageGeneral:["",Validators.required],
        CustSeeArizot:["",Validators.required],
        CustBlockParam3:["",Validators.required],
        CustSeePrice:["",Validators.required],
        CustChangeCss:["",Validators.required],
        CustChangeCss1:["",Validators.required],
        CustChangeCss2:["",Validators.required],
        CustChangeCss3:["",Validators.required],
        CustChangeCss4:["",Validators.required],
        CustChangeCss5:["",Validators.required],
        CustChangeCss6:["",Validators.required],
        CustChangeCss7:["",Validators.required],
        CustChangeCss8:["",Validators.required],
        CustChangeCss9:["",Validators.required],
        CustChangeCss10:["",Validators.required],
        CustAhuzAnaha:["",Validators.required],

        })
    }

  }

  //=====================================================================================================================================================================================================================================================================>
  public UpdateName(){

    this.Loading = true

    if(this.form.controls.CustName.value.length >1){
      this._ss.UpdateName({CustNum:this.Customer.CustNum,CustName:this.form.controls.CustName.value}).subscribe(
        res=>{
              alert("בוצע בהצלחה")
              this.Loading = false
        },err=>{
          alert("ארעה שגיאה אנא נסה שנית")
          this.Loading = false
        }
      )
    }

  }

  public UpdateNum(){

    this.Loading = true
    if(this.form.controls.CustNum.value.length >1){
      this._ss.UpdateNum({CustNum:this.Customer.CustNum,CustNewNum:this.form.controls.CustNum.value}).subscribe(
        res=>{
              alert("בוצע בהצלחה")
              this.Loading = false
        },err=>{
          alert("ארעה שגיאה אנא נסה שנית")
          this.Loading = false
        }
      )
    }
    
    
  }

  public UpdateServer(){
    this.Loading = true
    if(this.form.controls.CustServer.value.length >5){
      this._ss.UpdateServer({CustNum:this.Customer.CustNum,CustServer:this.form.controls.CustServer.value}).subscribe(
        res=>{
              alert("בוצע בהצלחה")
              this.Loading = false
        },err=>{
          alert("ארעה שגיאה אנא נסה שנית")
          this.Loading = false
        }
      )
    }
    
  }

  public UpdateImageDomain(){
    this.Loading = true
    if(this.form.controls.CustImageDomain.value.length >5){
      this._ss.UpdateImageDomain({CustNum:this.Customer.CustNum,CustImageDomain:this.form.controls.CustImageDomain.value}).subscribe(
        res=>{
              alert("בוצע בהצלחה")
              this.Loading = false
        },err=>{
          alert("ארעה שגיאה אנא נסה שנית")
          this.Loading = false
        }
      )
    }
    
  }
 
  public UpdateSeeImages(){
    this.Loading = true
    this._ss.UpdateSeeImages({CustNum:this.Customer.CustNum,CustSeeImages:this.form.controls.CustSeeImages.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
  }

  public UpdateSeeImageGeneral(){
    this.Loading = true
    this._ss.UpdateSeeImageGeneral({CustNum:this.Customer.CustNum,CustSeeImageGeneral:this.form.controls.CustSeeImageGeneral.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
  }

  public UpdateSeeArizot(){
    this.Loading = true
    this._ss.UpdateSeeArizot({CustNum:this.Customer.CustNum,CustSeeArizot:this.form.controls.CustSeeArizot.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateBlockParam3(){

    this._ss.UpdateBlockParam3({CustNum:this.Customer.CustNum,CustBlockParam3:this.form.controls.CustBlockParam3.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
  }

  public UpdateSeePrice(){
    this.Loading = true
    this._ss.UpdateSeePrice({CustNum:this.Customer.CustNum,CustSeePrice:this.form.controls.CustSeePrice.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateChangeCss(){
    this.Loading = true
    this._ss.UpdateChangeCss({CustNum:this.Customer.CustNum,CustChangeCss:this.form.controls.CustChangeCss.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateChangeCss1(){
    this.Loading = true
    this._ss.UpdateChangeCss1({CustNum:this.Customer.CustNum,CustChangeCss1:this.form.controls.CustChangeCss1.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateAhuzAnaha(){
    this.Loading = true
    this._ss.UpdateAhuzAnaha({CustNum:this.Customer.CustNum,CustAhuzAnaha:this.form.controls.CustAhuzAnaha.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        this.Loading = false
        alert("ארעה שגיאה אנא נסה שנית")
      }
    )

  }

  public UpdateChangeCss2(){
    this.Loading = true
    this._ss.UpdateChangeCss2({CustNum:this.Customer.CustNum,CustChangeCss2:this.form.controls.CustChangeCss2.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateChangeCss3(){
    this.Loading = true
    this._ss.UpdateChangeCss3({CustNum:this.Customer.CustNum,CustChangeCss3:this.form.controls.CustChangeCss3.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateChangeCss4(){
    this.Loading = true
    this._ss.UpdateChangeCss4({CustNum:this.Customer.CustNum,CustChangeCss4:this.form.controls.CustChangeCss4.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }

  public UpdateChangeCss5(){
    this.Loading = true
    this._ss.UpdateChangeCss5({CustNum:this.Customer.CustNum,CustChangeCss5:this.form.controls.CustChangeCss5.value}).subscribe(
      res=>{
            alert("בוצע בהצלחה")
            this.Loading = false
      },err=>{
        alert("ארעה שגיאה אנא נסה שנית")
        this.Loading = false
      }
    )
    
  }


  public prompt(){
    let person = prompt("הקלד כן כדי למחוק לקוח");
    if(person === "כן"){
      this._ss.DeleteClient({CustNum:this.Customer.CustNum}).subscribe(
        res=>{

        }
      )
    }
  }
  



// CustAhuzAnaha: "0"
// CustBlockParam3: "0"
// CustChangeCss: "1"
// CustChangeCss1: "0"
// CustChangeCss2: "0"
// CustChangeCss3: "0"
// CustChangeCss4: "0"
// CustChangeCss5: "0"
// CustDashbord: ""
// CustDomain: ""
// CustERP: ""
// CustExtra: ""
// CustExtra1: ""
// CustExtra2: ""
// CustExtra3: ""
// CustExtra4: ""
// CustExtra5: ""
// CustImageDomain: "https://orshanimobility.s3.eu-central-1.amazonaws.com/assets"
// CustName: "Or Shani"
// CustNotes: ""
// CustNotes1: ""
// CustNum: "10033"
// CustSeeArizot: "0"
// CustSeeImageGeneral: "0"
// CustSeeImages: "0"
// CustSeePrice: "0"
// CustServer: "http://Orshani-env.eba-bheq7s8m.eu-central-1.elasticbeanstalk.com"
// CustShowExtraHarot: "0"
// CustVersion: "0.0"

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  public Back(){
  this.router.navigate(['dashbord'])
  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->

  public burgerMenu
  public headerAbsolute
  public burgerMenuNoScroll
  public showLogoutPopup
  showHideMenu(value: boolean): void {
    this.burgerMenu = value;

    if (value) {
      this.headerAbsolute = value;
      this.burgerMenuNoScroll = value;
    } else {
      setTimeout(() => {
        this.headerAbsolute = value;
        this.burgerMenuNoScroll = value;
      }, 1000);
    }
  }

  showHideLogoutPopup(value: boolean): void {
    this.showLogoutPopup = value;
  }

  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
}

